import { RouteType } from "types/RouteType";
import DomainMappingsStore from "./DomainMappingsStore";

const domainMappingsRoute: RouteType[] = [
  {
    name: "DomainMappings",
    path: "/meeting-domain-mappings",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Domain Mappings",
        enableRefreshButton: true,
        component: () => import("./DomainMappings.Header"),
      },
      body: {
        component: () => import("./DomainMappings.Body"),
        grayBackground: true,
      },
    },
    group: "Meeting Intelligence",
    searchAliases: ["email domains", "partner domains"],
    requiresAuth: true,
    requiresAdmin: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      (rootStore.domainMappingsStore as DomainMappingsStore)?.load();
    },
  },
];

export default domainMappingsRoute;
